import classNames from 'classnames'
import { useCallback } from 'react'

import type { ReactElement, ChangeEvent } from 'react'

import SelectInput from '~/components/Inputs/Basic/SelectInput'

import './styles.scss'

export interface Props {
  className?: string
  entriesName: string
  maxNumberEntries?: number
  numberPerPage: number
  setNumberPerPage: (value: number) => void
  totalNumberElements: number
}

const MAX_NUMBER_ENTRIES = 50

const getEntriesOptions = (totalElements: number) => {
  const baseArray = Array.from({ length: totalElements }, (_, i) => i + 1).filter((el) => {
    return el > 0 && el % 10 === 0
  })

  const baseOptions = baseArray.map((el) => ({ label: el, value: el }))

  totalElements % 10 !== 0 &&
    baseOptions.push({
      label: getRoundedLastPage(totalElements),
      value: getRoundedLastPage(totalElements),
    })

  return baseOptions
}

const getRoundedLastPage = (totalPage: number) => {
  return Math.ceil(totalPage / 10) * 10
}

const ShowItems = ({
  className,
  entriesName,
  maxNumberEntries = MAX_NUMBER_ENTRIES,
  numberPerPage,
  setNumberPerPage,
  totalNumberElements,
}: Props): ReactElement => {
  /** Local state */

  const entriesOptions = getEntriesOptions(
    totalNumberElements < maxNumberEntries ? totalNumberElements : maxNumberEntries
  )
  const defaultValue = numberPerPage
    ? entriesOptions.find((option) => option.value === numberPerPage)
    : entriesOptions.find((option) => option.value === 10)

  /** Handlers */

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLSelectElement>) => {
      // @ts-expect-error value does not exist on ChangeEvent
      localStorage.setItem(`${entriesName}`, `${+event.value}`)
      const numberPerPageFromLocalStorage = localStorage.getItem(`${entriesName}`) ?? '10'
      setNumberPerPage(+numberPerPageFromLocalStorage)
    },
    [entriesName, setNumberPerPage]
  )

  /** Render */

  return (
    <div className={classNames('show-items-component', className)}>
      <span>Show</span>
      <div className="select-wrapper">
        <SelectInput
          isDisabled={totalNumberElements <= 10}
          isSearchable
          // @ts-expect-error invalid signature
          onChange={handleChange}
          options={entriesOptions}
          size={'small'}
          value={defaultValue}
        />
      </div>
      <span className="out-of"> items out of </span>
      <div className="total"> {totalNumberElements} </div>
    </div>
  )
}

export default ShowItems
